import _pick from 'lodash/pick';

export const filterSessionSettings = settings => {
    const filteredSettings = {
        ...settings,
        sessionCollection: settings.sessionCollection.map(sc => {
            return {
                ...sc,
                resource: _pick(sc.resource, [
                    'id',
                    'handle',
                    'published_label',
                    'published_description',
                    'published_metadata',
                ]),
            };
        }),
    };
    return filteredSettings;
};

const getFlowLanguages = metadata => {
    let languages = new Set();
    if (metadata.surveyInfo && metadata.surveyInfo.flowList) {
        metadata.surveyInfo.flowList.forEach(flow => {
            languages.add(flow.language);
        });
    }
    return [...languages];
};

export const formatResourcesForCollection = resourceList => {
    const formattedResources = resourceList.map(r => {
        // metadata may come back from GraphQL as a JSON string or an already-parsed object
        const metadata = typeof r.metadata === 'string' ? JSON.parse(r.metadata) : r.metadata || {};
        const tags = r.tagList.reduce((acc, cur) => ({ ...acc, [cur.tagId]: cur.handle }), {});
        return {
            id: r.resourceId,
            label: r.label,
            description: r.description,
            tags,
            languages: getFlowLanguages(metadata),
            resource: { published_metadata: JSON.stringify(metadata) },
        };
    });

    return formattedResources;
};

export const stripHtml = html => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
};

export const getFormattedDate = date => {
    date = new Date(date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};
